export default "__VITE_ASSET__DOcvdSuE__"